import React, { useEffect, useState } from "react";
import client from "../../client/Client";
import { Link } from "react-router-dom";
import HeaderBanner from "../ui/HeaderBanner";

interface myDATA {
  Email: string;
  Deadline: string;
  _type: string;
  _key: string;
  CallForSpecialSessionsTF: {
    _type: string;
    asset: {
      _ref: string;
      _type: string;
    };
  };
}

const CallforSpecialSessions = () => {
  const [data, setData] = useState<myDATA>();
  const [versionYear, setVersionYear] = useState("");

  useEffect(() => {
    client
      .fetch('*[_type == "Programs"]')
      .then((result) => {
        setData(result[0].CallForSpecialSessions[0]);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
      
    client
      .fetch('*[_type == "YearVersion"]')
      .then((result) => {
        setVersionYear("20".concat(result[0].YearVersion?.slice(-2)));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getTemplateUrl = () => {
    if (!data?.CallForSpecialSessionsTF?.asset?._ref) return '';
    return `https://cdn.sanity.io/files/79vgbaej/production/${data.CallForSpecialSessionsTF.asset._ref.slice(5, -4)}.${data.CallForSpecialSessionsTF.asset._ref.slice(-3)}`;
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title='Call for Special Sessions' />
      
      <div className="text-left space-y-8 pt-12">
        {/* Main Title Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
            Special Session Proposal
          </h1>
          <p className="text-gray-700 text-lg">
            Submit your special session proposal for SSD {versionYear} to focus on specific topics within our conference objectives.
          </p>
        </div>

        {/* SSD Call for Special Sessions Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            SSD Call for Special Sessions
          </h2>
          <div className="space-y-4">
            <p className="text-gray-700 leading-relaxed">
              The IEEE International Multi-Conference on Systems, Signals and Devices {versionYear} (SSD {versionYear}) welcome and encourage the proposal of special sessions, which aim focusing on specific topics within the main objectives of the fourth conference. Indeed, in addition to the regular sessions, special sessions will helps authors to submit papers, which can cover related topics to each conference under subjects or cross-subjects of specific interests of innovation, updated research topics, current novel projects and new advance in <Link className="text-red-600 hover:text-red-800 font-medium" to={"/sac"}>Systems, Automation & Control (SAC)</Link>, <Link className="text-red-600 hover:text-red-800 font-medium" to={"/pse"}>Power Systems & Smart Energies (PSE)</Link>, <Link className="text-red-600 hover:text-red-800 font-medium" to={"/csp"}>Communication and Signal Processing & Information Technology (CSP)</Link>, <Link className="text-red-600 hover:text-red-800 font-medium" to={"/sci"}>Sensors, Circuits and Instrumentation Systems (SCI)</Link>. For details of each conference's topics, please check with the link of each conference within the website of SSD {versionYear}.
            </p>
            
            {data && (
              <p className="text-gray-700 leading-relaxed">
                All interested researchers or academics who would like to propose and organize a special session should send their Special Sessions proposal to the Chairs of the special sessions at: <a className="text-red-600 hover:text-red-800 font-medium" href={`mailto:${data?.Email}`}>{data?.Email}</a>. All proposals have to be submitted using the Special Session Template and including the following information:
              </p>
            )}
          </div>
        </div>

        {/* Proposal Requirements Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Proposal Requirements
          </h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Title of the Special Session</li>
            <li>The number of one special session organizers is not limited but preferred from at least two countries.</li>
            <li>The full names, affiliations and contact information of all the special session organizers should be provided</li>
            <li>A short abstract describing the covered specific topic in (approx. 300 words). This abstract has to be ended with the answer of the question: Why you believe that the proposal is a significant and interesting subject?</li>
            <li>A list of sub-topics related to the proposal (not more than 12 sub-topics)</li>
            <li>A list of potential authors and their affiliations (not less than 20)</li>
            <li>A list of international potential reviewers and their affiliations (at least 20, but not all from the same country)</li>
          </ul>
          
          {/* Template Download Button */}
          {data && (
            <div className="flex justify-center mt-6">
              <a
                href={getTemplateUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-902 hover:text-white bg-white border-2 border-blue-901 rounded-lg px-6 py-3 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center inline-block"
              >
                <span className=" font-semibold text-lg">
                  Download Template
                </span>
              </a>
            </div>
          )}
        </div>

        {/* Organization of Special Sessions Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Organization of Special Sessions
          </h2>
          <div className="space-y-4 mb-6">
            <p className="text-gray-700 leading-relaxed">
              The proposal of Special Session will be reviewed by the Chairs of special sessions and the decision of approval will be provided to the organizers in less than 5 working days. Once the proposal is accepted and approved, it is the responsibility of the organizers to disseminate, distribute and publicize their Special Session (SS) among academics, students, researchers, industry and practitioners interested by the proposed topic of the SS to attract a sufficient number of submissions.
            </p>
            <p className="text-gray-700 leading-relaxed">
              The organizers of special session should follow strictly the rules of organizing a special session:
            </p>
          </div>
          
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>The registration process is the same as for regular papers.</li>
            <li>The special session cannot accept the submission of more than two papers, which are co-authored by the same author (among the authors of the paper).</li>
            <li>The review process will be the responsibility of the organizers of the special session and with follow-up by the Chairs of special sessions. However, the review process will undergo the same process as regular papers and the reviewers should not have any contact or interest with the authors of the paper.</li>
            <li>In case of conflict of interest, which means if the special session organizer has a paper co-authored by them, the review should be in a strict way where the review should choose in a way to avoid such conflict.</li>
            <li>The total percentage of the papers co-authored by at least one of the organizers should not in any way exceed 60%</li>
            <li>All special session papers are presented as one or more oral sessions where each oral session should not include more than six papers.</li>
          </ul>
        </div>

        {/* Important Notes Section */}
        <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Important Notes
          </h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
            <li>Free registration will be provided to the organizers of a successful special session for every 5 papers not co-authored by any author among the organizers. This free registration can be used by the organizers fully or divided among two or more organizers based on 100% of one free full registration (as an example two organizers can benefit from a 50% discount for each for one paper to each).</li>
            <li>During the conference, the successful special session will be organized with the oral sessions, which will be chaired by the organizers who will attend the conference.</li>
            <li>If the organizer will not be able to attend the conference, the Chairs of the special sessions will delegate a colleague to chair the mentioned oral sessions.</li>
          </ul>
          
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <p className="text-gray-700 mb-2">
              For any further information or enquiries concerning the organization of a special session please contact Special session organizer:{" "}
              <a className="text-red-600 hover:text-red-800 font-medium" href={`mailto:${data?.Email}`}>{data?.Email}</a>
            </p>
            <p className="text-gray-700 font-semibold">
              Special Session Proposal Deadline: <span className="text-red-600">{data?.Deadline}</span>
            </p>
          </div>
        </div>

        {/* Contact Section */}
        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Need Assistance?
          </h3>
          <p className="text-gray-700">
            For any questions regarding special sessions, please contact:{" "}
            <a className="text-red-600 hover:text-red-800 font-medium underline" href={`mailto:${data?.Email}`}>
              {data?.Email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CallforSpecialSessions;